import { shallowEqual, useSelector } from "react-redux";
import ReportsPage from "./ReportsPage";
import { RootState } from "../../../setup";
import { UserRoles } from "../../enums/userRoles";
import { DEFAULT_ROUTE } from "../../routing/routes.config";
import { Redirect } from "react-router-dom";

const ReportsWrapper = () => {
    const user = useSelector((state: RootState) => state.auth.user, shallowEqual);
    
    if(!user || user.role === UserRoles.CLIENT || user.role === UserRoles.FINAL_USER)
    return <Redirect to={DEFAULT_ROUTE} />;
    
    return (
        <>
            <ReportsPage />
        </>
    )
}

export default ReportsWrapper;